module.exports = __webpack_public_path__ + "static/img/Geos-2022-Tatiana.b7a7cec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Geos-2022-Tatiana.png
// module id = MuBU
// module chunks = 0